import { isMobile } from './is-mobile'

/*
 * menu-trigger btn
 * ----------------------------------------------- */
const menuTrigger = document.querySelector('.menu-trigger');
const navLinks = document.querySelectorAll('.navbar-nav a');
const logo = document.querySelector('.navbar-brand');

menuTrigger.addEventListener('click', function (e) {
  e.preventDefault();

  const target = document.getElementById(this.getAttribute('aria-controls'));
  const expanded = this.getAttribute('aria-expanded') === 'true';

  this.setAttribute('aria-expanded', !expanded);
  target.classList.toggle('active');
  logo.classList.toggle('active', !expanded);
});


navLinks.forEach(link => {
  link.addEventListener('click', () => {
    if (isMobile()) {
      menuTrigger.click();
    }
  });
});

